import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserDecisionDisplayName, UserDecisionEnum } from '@bo-client/shared/constants/enums';

@Component({
  selector: 'app-user-decision-radio-buttons',
  templateUrl: './user-decision-radio-buttons.component.html',
  styleUrl: './user-decision-radio-buttons.component.scss'
})
export class UserDecisionRadioButtonsComponent {
  @Input() label: string;
  @Input() control: FormControl<UserDecisionEnum>;
  @Input() isDisabled = false;
  @Input() isEditorView = false;

  readonly userDecisionOptions = Object.values(UserDecisionEnum);

  displayName(option: string) {
    return this.isEditorView && option === UserDecisionEnum.UNKNOWN
      ? 'Unbekannt'
      : UserDecisionDisplayName[option as UserDecisionEnum];
  }
}
